module.exports = __webpack_public_path__ + "img/S1.c04f27d9.jpg";